$(document).ready(function () {
  var newsPageHandle = "ratgeber";
  var currentLang = window.currentLang;
  if (currentLang == "de" || currentLang == "de_CH") {
    currentLang = "de_CH";
    var site_url = "";
  } else {
    var site_url = "/" + currentLang;
  }

  console.log('site_url', site_url, currentLang);

  var settings = {
    url:
      API_URL +
      "news?page[number]=1&page[size]=3&sort=-publishDate&filter[isActive]=1&filter[isLightVersion]=1&filter[newsCategoryId]=35",
    method: "GET",
    timeout: 0,
    headers: {
      Authorization: Authorization,
      Accept: "application/vnd.api+json",
      "Cache-Control": "max-age=600",
      "Content-Encoding": "application/gzip",
    },
    beforeSend: function (xhr) {
      // $('.section-hero-banner').addClass('d-none');
    },
  };
  $.ajax(settings).done(async function (response) {
    let count = $("#news-container .about-news-list").data("count")
    let newsCount = await appendNews(response, "#news-container .about-news-list", count, 0);
    console.log("newsCount", newsCount);
    if (newsCount === 0) {
      $("#news-container .btn-all-news").addClass("hidden")
    }
  });

  function appendNews (response, target, count, offset) {
    console.log(response, count, offset);
    var totalData = response.data.length;
    var loopCount = count != "" ? count + offset : "";
    if (loopCount != "" && loopCount < totalData) {
      totalData = loopCount;
    }
    let html = "";
    if(totalData > offset){
      for(var a=0; a < totalData; a++){
        if (offset != 0 && a < offset) {
          html += "";
        } else {
          var json_response = response.data[a].attributes;

          var title = jQuery.trim(json_response.name);
          var description = json_response.excerpt || '';
          var imagesrc = json_response.optimizedListImage || json_response.optimizedImage || json_response.image || json_response.headlineImage || shopLogo;

          var focusXPercentage = json_response.focusXPercentage ? json_response.focusXPercentage + '%' : 'top';
          var focusYPercentage = json_response.focusYPercentage ? json_response.focusYPercentage + '%' : 'center';

          var url = json_response.urlHandle || response.data[a].id;

          html += `
            <div class="col-md-4 col-sm-6 col-xs-12 column thumbnail">
              <div class="news-wrapper">
                <div class="image-wrapper">
                  <a href="${site_url}/pages/${newsPageHandle}/${url}">
                    <img src="${imagesrc}" width="320" class="lazyload" loading="lazy" style="object-position: ${focusXPercentage} ${focusYPercentage}">
                  </a>
                </div>
                <div class="content-wrapper">
                  <div class="newsblock__date">
                    ${formatDateString(response.data[a].attributes.publishDate, 'regular', 'false')}
                  </div>
                  <p class="newsblock__title">
                    <a href="${site_url}/pages/${newsPageHandle}/${url}" class="block-btn">
                      ${title}
                      ${description !== '' && description !== null ? `: <span class="newsblock__details">${description}</span>` : ''}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          `;
        }
      }
    }else{
      html +=`<div class="col-md-4 col-sm-6 col-xs-12 column no-news"><p>Nachrichten sind in dieser Sammlung nicht verfügbar</p></div>`
    }
    $(target).append(html);
    $(target).closest(".news-page-container").find(".preloading").remove();

    return totalData
  }
});
